exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".image.-responsive{max-width:100%}.image.-fullwidth{width:100%}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAEE,mBACE,cAAA,CAGF,kBACE,UAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n.image {\n  &.-responsive {\n    max-width: 100%;\n  }\n\n  &.-fullwidth {\n    width: 100%;\n  }\n}\n"]}]);

// Exports
exports.locals = {
	"image": "image",
	"-responsive": "-responsive",
	"-fullwidth": "-fullwidth"
};